import m from "../../geodata/es2015/dominicanRepublicHigh";
window.am4geodata_dominicanRepublicHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/dominicanRepublicHigh.js
// module id = null
// module chunks = 